var map = {
	"./00.png": 31297,
	"./A1.png": 56393,
	"./AD.png": 43708,
	"./AE.png": 72020,
	"./AF.png": 47628,
	"./AG.png": 99498,
	"./AI.png": 85655,
	"./AL.png": 21850,
	"./AM.png": 15030,
	"./AN.png": 66997,
	"./AO.png": 6516,
	"./AP.png": 81073,
	"./AQ.png": 77142,
	"./AR.png": 31093,
	"./AS.png": 74779,
	"./AT.png": 31351,
	"./AU.png": 47929,
	"./AW.png": 82209,
	"./AX.png": 68181,
	"./AZ.png": 60802,
	"./Abkhazia.png": 22593,
	"./Afghanistan.png": 47710,
	"./Aland.png": 28949,
	"./Albania.png": 64416,
	"./Algeria.png": 74008,
	"./American-Samoa.png": 47336,
	"./Andorra.png": 40733,
	"./Angola.png": 22649,
	"./Anguilla.png": 88410,
	"./Antarctica.png": 41234,
	"./Antigua-and-Barbuda.png": 32711,
	"./Argentina.png": 7216,
	"./Armenia.png": 34206,
	"./Aruba.png": 54645,
	"./Australia.png": 70639,
	"./Austria.png": 49592,
	"./Azerbaijan.png": 54808,
	"./BA.png": 48805,
	"./BB.png": 91415,
	"./BD.png": 35538,
	"./BE.png": 72423,
	"./BF.png": 73642,
	"./BG.png": 11359,
	"./BH.png": 36030,
	"./BI.png": 89693,
	"./BJ.png": 19501,
	"./BL.png": 7678,
	"./BM.png": 40685,
	"./BN.png": 16098,
	"./BO.png": 76515,
	"./BQ.png": 80686,
	"./BR.png": 47133,
	"./BS.png": 10311,
	"./BT.png": 15156,
	"./BV.png": 40306,
	"./BW.png": 83744,
	"./BY.png": 96194,
	"./BZ.png": 66067,
	"./Bahamas.png": 66697,
	"./Bahrain.png": 54587,
	"./Bangladesh.png": 81105,
	"./Barbados.png": 82782,
	"./Basque-Country.png": 56539,
	"./Belarus.png": 52798,
	"./Belgium.png": 42313,
	"./Belize.png": 7466,
	"./Benin.png": 29737,
	"./Bermuda.png": 65063,
	"./Bhutan.png": 95244,
	"./Bolivia.png": 31793,
	"./Bosnia-and-Herzegovina.png": 22199,
	"./Botswana.png": 86087,
	"./Brazil.png": 67734,
	"./British-Antarctic-Territory.png": 26246,
	"./British-Virgin-Islands.png": 32476,
	"./Brunei.png": 46812,
	"./Bulgaria.png": 47830,
	"./Burkina-Faso.png": 80834,
	"./Burundi.png": 4091,
	"./CA.png": 21158,
	"./CC.png": 53226,
	"./CD.png": 4233,
	"./CF.png": 76489,
	"./CG.png": 88142,
	"./CH.png": 79873,
	"./CI.png": 43790,
	"./CK.png": 82551,
	"./CL.png": 71782,
	"./CM.png": 61012,
	"./CN.png": 15702,
	"./CO.png": 75436,
	"./CR.png": 72425,
	"./CT.png": 44142,
	"./CU.png": 23784,
	"./CV.png": 97585,
	"./CW.png": 97489,
	"./CX.png": 14816,
	"./CY.png": 89445,
	"./CZ.png": 40449,
	"./Cambodia.png": 15273,
	"./Cameroon.png": 26882,
	"./Canada.png": 62280,
	"./Canary-Islands.png": 17232,
	"./Cape-Verde.png": 14307,
	"./Catalonia.png": 43811,
	"./Cayman-Islands.png": 19211,
	"./Central-African-Republic.png": 26912,
	"./Chad.png": 72072,
	"./Chile.png": 81010,
	"./China.png": 82825,
	"./Christmas-Island.png": 56151,
	"./Cocos-Keeling-Islands.png": 49855,
	"./Colombia.png": 71781,
	"./Commonwealth.png": 16526,
	"./Comoros.png": 7815,
	"./Cook-Islands.png": 73730,
	"./Costa-Rica.png": 85582,
	"./Cote-dIvoire.png": 70354,
	"./Croatia.png": 1522,
	"./Cuba.png": 62841,
	"./Curacao.png": 60164,
	"./Cyprus.png": 86066,
	"./Czech-Republic.png": 55143,
	"./DE.png": 53886,
	"./DJ.png": 12503,
	"./DK.png": 87955,
	"./DM.png": 42474,
	"./DO.png": 33958,
	"./DZ.png": 9366,
	"./Democratic-Republic-of-the-Congo.png": 74077,
	"./Denmark.png": 68326,
	"./Djibouti.png": 39285,
	"./Dominica.png": 40608,
	"./Dominican-Republic.png": 8483,
	"./EC.png": 53854,
	"./EE.png": 90080,
	"./EG.png": 16787,
	"./EH.png": 50350,
	"./ER.png": 71923,
	"./ES.png": 6400,
	"./ET.png": 12224,
	"./EU.png": 41292,
	"./East-Timor.png": 18331,
	"./Ecuador.png": 53837,
	"./Egypt.png": 95625,
	"./El-Salvador.png": 30298,
	"./England.png": 36776,
	"./Equatorial-Guinea.png": 46435,
	"./Eritrea.png": 92067,
	"./Estonia.png": 99458,
	"./Ethiopia.png": 82683,
	"./European-Union.png": 1220,
	"./FI.png": 39242,
	"./FJ.png": 97633,
	"./FK.png": 50409,
	"./FM.png": 41756,
	"./FO.png": 31623,
	"./FR.png": 92339,
	"./Falkland-Islands.png": 60889,
	"./Faroes.png": 77193,
	"./Fiji.png": 34246,
	"./Finland.png": 77169,
	"./France.png": 71495,
	"./French-Polynesia.png": 13274,
	"./French-Southern-Territories.png": 70784,
	"./GA.png": 61918,
	"./GB.png": 79830,
	"./GD.png": 69909,
	"./GE.png": 26401,
	"./GF.png": 325,
	"./GG.png": 73211,
	"./GH.png": 53801,
	"./GI.png": 99963,
	"./GL.png": 35532,
	"./GM.png": 31287,
	"./GN.png": 31362,
	"./GP.png": 37828,
	"./GQ.png": 18266,
	"./GR.png": 7736,
	"./GS.png": 77450,
	"./GT.png": 98727,
	"./GU.png": 99496,
	"./GW.png": 77380,
	"./GY.png": 4439,
	"./Gabon.png": 4658,
	"./Gambia.png": 75228,
	"./Georgia.png": 30669,
	"./Germany.png": 56698,
	"./Ghana.png": 48613,
	"./Gibraltar.png": 81567,
	"./GoSquared.png": 8211,
	"./Greece.png": 67217,
	"./Greenland.png": 98285,
	"./Grenada.png": 158,
	"./Guam.png": 10588,
	"./Guatemala.png": 2990,
	"./Guernsey.png": 45057,
	"./Guinea-Bissau.png": 85827,
	"./Guinea.png": 77035,
	"./Guyana.png": 55401,
	"./HK.png": 94659,
	"./HM.png": 21807,
	"./HN.png": 90774,
	"./HR.png": 40254,
	"./HT.png": 28656,
	"./HU.png": 31700,
	"./Haiti.png": 68079,
	"./Honduras.png": 85112,
	"./Hong-Kong.png": 24845,
	"./Hungary.png": 33120,
	"./IC.png": 85365,
	"./ID.png": 77272,
	"./IE.png": 70380,
	"./IL.png": 4217,
	"./IM.png": 21058,
	"./IN.png": 7503,
	"./INTL.png": 43961,
	"./IO.png": 97238,
	"./IQ.png": 1155,
	"./IR.png": 73722,
	"./IS.png": 96142,
	"./IT.png": 84659,
	"./Iceland.png": 77317,
	"./India.png": 58387,
	"./Indonesia.png": 31840,
	"./Iran.png": 95585,
	"./Iraq.png": 67489,
	"./Ireland.png": 70661,
	"./Isle-of-Man.png": 35649,
	"./Israel.png": 52827,
	"./Italy.png": 67866,
	"./JE.png": 38205,
	"./JM.png": 92722,
	"./JO.png": 80350,
	"./JP.png": 95082,
	"./Jamaica.png": 83757,
	"./Japan.png": 68342,
	"./Jersey.png": 41479,
	"./Jordan.png": 62566,
	"./KE.png": 90646,
	"./KG.png": 63926,
	"./KH.png": 90147,
	"./KI.png": 91674,
	"./KM.png": 97428,
	"./KN.png": 3081,
	"./KP.png": 6046,
	"./KR.png": 40038,
	"./KW.png": 40001,
	"./KY.png": 10052,
	"./KZ.png": 13649,
	"./Kazakhstan.png": 494,
	"./Kenya.png": 3739,
	"./Kiribati.png": 98297,
	"./Kosovo.png": 99298,
	"./Kuwait.png": 68656,
	"./Kyrgyzstan.png": 2377,
	"./LA.png": 36487,
	"./LB.png": 26205,
	"./LC.png": 63265,
	"./LI.png": 37423,
	"./LK.png": 53138,
	"./LR.png": 44050,
	"./LS.png": 33439,
	"./LT.png": 77040,
	"./LU.png": 15297,
	"./LV.png": 26887,
	"./LY.png": 78074,
	"./Laos.png": 9114,
	"./Latvia.png": 52372,
	"./Lebanon.png": 81395,
	"./Lesotho.png": 61264,
	"./Liberia.png": 32477,
	"./Libya.png": 45799,
	"./Liechtenstein.png": 99696,
	"./Lithuania.png": 47204,
	"./Luxembourg.png": 88249,
	"./MA.png": 26150,
	"./MC.png": 10759,
	"./MD.png": 14738,
	"./ME.png": 98761,
	"./MF.png": 91150,
	"./MG.png": 68854,
	"./MH.png": 5832,
	"./MK.png": 45643,
	"./ML.png": 9650,
	"./MM.png": 27208,
	"./MN.png": 28111,
	"./MO.png": 34015,
	"./MP.png": 27375,
	"./MQ.png": 22085,
	"./MR.png": 7251,
	"./MS.png": 32256,
	"./MT.png": 59173,
	"./MU.png": 7359,
	"./MV.png": 34630,
	"./MW.png": 4375,
	"./MX.png": 3025,
	"./MY.png": 98637,
	"./MZ.png": 95094,
	"./Macau.png": 55787,
	"./Macedonia.png": 71873,
	"./Madagascar.png": 48885,
	"./Malawi.png": 25639,
	"./Malaysia.png": 43413,
	"./Maldives.png": 11509,
	"./Mali.png": 92673,
	"./Malta.png": 88240,
	"./Mars.png": 8257,
	"./Marshall-Islands.png": 47471,
	"./Martinique.png": 14471,
	"./Mauritania.png": 7307,
	"./Mauritius.png": 36619,
	"./Mayotte.png": 76522,
	"./Mexico.png": 41752,
	"./Micronesia.png": 48933,
	"./Moldova.png": 67814,
	"./Monaco.png": 3625,
	"./Mongolia.png": 65306,
	"./Montenegro.png": 5479,
	"./Montserrat.png": 13653,
	"./Morocco.png": 43244,
	"./Mozambique.png": 52714,
	"./Myanmar.png": 40548,
	"./NA.png": 89384,
	"./NATO.png": 64502,
	"./NC.png": 77982,
	"./NE.png": 17142,
	"./NF.png": 35749,
	"./NG.png": 53795,
	"./NI.png": 22936,
	"./NL.png": 44486,
	"./NO.png": 29984,
	"./NP.png": 77310,
	"./NR.png": 13028,
	"./NU.png": 72163,
	"./NZ.png": 47043,
	"./Nagorno-Karabakh.png": 20682,
	"./Namibia.png": 30457,
	"./Nauru.png": 31811,
	"./Nepal.png": 21123,
	"./Netherlands-Antilles.png": 46281,
	"./Netherlands.png": 99362,
	"./New-Caledonia.png": 23625,
	"./New-Zealand.png": 84409,
	"./Nicaragua.png": 74937,
	"./Niger.png": 62417,
	"./Nigeria.png": 62685,
	"./Niue.png": 43025,
	"./Norfolk-Island.png": 41909,
	"./North-Korea.png": 99984,
	"./Northern-Cyprus.png": 51875,
	"./Northern-Mariana-Islands.png": 8644,
	"./Norway.png": 41355,
	"./OM.png": 87682,
	"./Olympics.png": 69375,
	"./Oman.png": 56612,
	"./PA.png": 62079,
	"./PE.png": 54114,
	"./PF.png": 8851,
	"./PG.png": 17164,
	"./PH.png": 37690,
	"./PK.png": 76263,
	"./PL.png": 89416,
	"./PM.png": 55893,
	"./PN.png": 46890,
	"./PR.png": 79849,
	"./PS.png": 16371,
	"./PT.png": 83060,
	"./PW.png": 19208,
	"./PY.png": 17104,
	"./Pakistan.png": 47087,
	"./Palau.png": 67412,
	"./Palestine.png": 50724,
	"./Panama.png": 52353,
	"./Papua-New-Guinea.png": 3199,
	"./Paraguay.png": 56045,
	"./Peru.png": 40241,
	"./Philippines.png": 82820,
	"./Pitcairn-Islands.png": 2384,
	"./Poland.png": 93139,
	"./Portugal.png": 62803,
	"./Puerto-Rico.png": 14818,
	"./QA.png": 32957,
	"./Qatar.png": 19589,
	"./RE.png": 58836,
	"./RO.png": 79053,
	"./RS.png": 39088,
	"./RU.png": 17663,
	"./RW.png": 90838,
	"./Red-Cross.png": 23103,
	"./Republic-of-the-Congo.png": 63786,
	"./Reunion.png": 45621,
	"./Romania.png": 21531,
	"./Russia.png": 95792,
	"./Rwanda.png": 56751,
	"./SA.png": 30585,
	"./SB.png": 72563,
	"./SC.png": 92460,
	"./SD.png": 62387,
	"./SE.png": 35349,
	"./SG.png": 76345,
	"./SH.png": 78394,
	"./SI.png": 39766,
	"./SJ.png": 6242,
	"./SK.png": 80325,
	"./SL.png": 37975,
	"./SM.png": 96357,
	"./SN.png": 82355,
	"./SO.png": 80466,
	"./SR.png": 59389,
	"./SS.png": 46161,
	"./ST.png": 30174,
	"./SV.png": 51954,
	"./SX.png": 96812,
	"./SY.png": 99422,
	"./SZ.png": 39319,
	"./Saint-Barthelemy.png": 26413,
	"./Saint-Helena.png": 74257,
	"./Saint-Kitts-and-Nevis.png": 25581,
	"./Saint-Lucia.png": 84356,
	"./Saint-Martin.png": 15933,
	"./Saint-Vincent-and-the-Grenadines.png": 30781,
	"./Samoa.png": 18442,
	"./San-Marino.png": 75513,
	"./Sao-Tome-and-Principe.png": 63521,
	"./Saudi-Arabia.png": 69166,
	"./Scotland.png": 62610,
	"./Senegal.png": 5489,
	"./Serbia.png": 12626,
	"./Seychelles.png": 32886,
	"./Sierra-Leone.png": 26149,
	"./Singapore.png": 19614,
	"./Sint-Maarten.png": 6631,
	"./Slovakia.png": 72140,
	"./Slovenia.png": 49914,
	"./Solomon-Islands.png": 46607,
	"./Somalia.png": 58384,
	"./Somaliland.png": 28283,
	"./South-Africa.png": 17358,
	"./South-Georgia-and-the-South-Sandwich-Islands.png": 27304,
	"./South-Korea.png": 9100,
	"./South-Ossetia.png": 68201,
	"./South-Sudan.png": 48163,
	"./Spain.png": 99260,
	"./Sri-Lanka.png": 1047,
	"./Sudan.png": 58114,
	"./Suriname.png": 86257,
	"./Swaziland.png": 4270,
	"./Sweden.png": 31166,
	"./Switzerland.png": 96549,
	"./Syria.png": 33239,
	"./TC.png": 96079,
	"./TD.png": 93448,
	"./TF.png": 89203,
	"./TG.png": 4238,
	"./TH.png": 5231,
	"./TJ.png": 63266,
	"./TK.png": 18764,
	"./TL.png": 86036,
	"./TM.png": 57030,
	"./TN.png": 16230,
	"./TO.png": 84327,
	"./TR.png": 21777,
	"./TT.png": 93467,
	"./TV.png": 97098,
	"./TW.png": 67628,
	"./TZ.png": 44732,
	"./Taiwan.png": 88917,
	"./Tajikistan.png": 95439,
	"./Tanzania.png": 68037,
	"./Thailand.png": 78381,
	"./Togo.png": 76769,
	"./Tokelau.png": 94894,
	"./Tonga.png": 37338,
	"./Trinidad-and-Tobago.png": 4923,
	"./Tunisia.png": 91920,
	"./Turkey.png": 64375,
	"./Turkmenistan.png": 39557,
	"./Turks-and-Caicos-Islands.png": 49368,
	"./Tuvalu.png": 63741,
	"./UA.png": 37186,
	"./UG.png": 39511,
	"./UM.png": 57174,
	"./US-Virgin-Islands.png": 78806,
	"./US.png": 14820,
	"./UY.png": 30923,
	"./UZ.png": 10007,
	"./Uganda.png": 69167,
	"./Ukraine.png": 32290,
	"./United-Arab-Emirates.png": 42626,
	"./United-Kingdom.png": 83638,
	"./United-Nations.png": 38754,
	"./United-States.png": 57606,
	"./Unknown.png": 72302,
	"./Uruguay.png": 69625,
	"./Uzbekistan.png": 88419,
	"./VA.png": 85568,
	"./VC.png": 62267,
	"./VE.png": 40215,
	"./VG.png": 37536,
	"./VI.png": 4539,
	"./VN.png": 24316,
	"./VU.png": 74471,
	"./Vanuatu.png": 76388,
	"./Vatican-City.png": 44071,
	"./Venezuela.png": 17263,
	"./Vietnam.png": 66056,
	"./WF.png": 52981,
	"./WS.png": 95174,
	"./Wales.png": 67713,
	"./Wallis-And-Futuna.png": 48666,
	"./Western-Sahara.png": 19794,
	"./XK.png": 60946,
	"./YE.png": 78909,
	"./YT.png": 46379,
	"./Yemen.png": 47054,
	"./ZA.png": 72498,
	"./ZM.png": 58127,
	"./ZW.png": 52515,
	"./Zambia.png": 77322,
	"./Zimbabwe.png": 59256,
	"./_abkhazia.png": 87100,
	"./_basque-country.png": 68823,
	"./_british-antarctic-territory.png": 71758,
	"./_commonwealth.png": 8430,
	"./_england.png": 84289,
	"./_gosquared.png": 10457,
	"./_kosovo.png": 93457,
	"./_mars.png": 51872,
	"./_nagorno-karabakh.png": 28240,
	"./_nato.png": 92791,
	"./_northern-cyprus.png": 23098,
	"./_olympics.png": 80933,
	"./_red-cross.png": 29570,
	"./_scotland.png": 23353,
	"./_somaliland.png": 81790,
	"./_south-ossetia.png": 5317,
	"./_united-nations.png": 82474,
	"./_unknown.png": 57510,
	"./_wales.png": 26153,
	"./null.png": 29253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47977;